/** @format */

import React from 'react';
import { useTranslation } from 'react-i18next/hooks';

const getSrc = () => {
	return window.location.origin + process.env.PUBLIC_URL + '/img/bgcar.png';
};

function Background() {
	const [t] = useTranslation('translation');

	return (
		<img
			className='collapsable-content background'
			src={getSrc()}
			alt='Bakground'
			title={t('backgroundImageTitle')}
		></img>
	);
}

export default Background;
